<template>
  <Card v-if="property" class="property-card">
    <CardHeader class="property-card-header">
      <router-link
        :to="{ name: 'property-detail', params: { id: property.id } }"
        class="property-name"
      >
        {{ property.name }}
      </router-link>
      <a
        v-if="property.wiki_hyperlink"
        :href="property.wiki_hyperlink"
        target="_blank"
        rel="noopener noreferrer"
        class="icon-link wiki-btn"
        aria-label="Открыть Wiki"
        title="Wiki"
      >
        <BookOpen :size="16" />
      </a>
    </CardHeader>
    <CardContent class="space-y-3">
      <div v-if="property.city" class="flex items-center gap-2 text-sm text-muted-foreground">
        <MapPin :size="14" class="shrink-0" />
        <span>
          {{ property.city.name }}
          <span
            v-if="property.city.utc_offset !== null && property.city.utc_offset !== undefined"
            class="text-xs"
          >
            (UTC{{ property.city.utc_offset >= 0 ? '+' : '' }}{{ property.city.utc_offset }})
          </span>
        </span>
      </div>
      <div v-if="hasActiveSupport" class="support-items">
        <div
          v-for="s in activeSupport"
          :key="s.product"
          class="support-item"
          :class="{
            'support-overdue': isOverdueSupport(s.support_till),
            'support-suspended': s.support_suspended,
          }"
        >
          <span class="mark">
            <CircleAlert
              v-if="isOverdueSupport(s.support_till) || s.support_suspended"
              :size="14"
              :title="s.support_suspended ? 'Поддержка приостановлена' : 'Поддержка просрочена'"
            />
          </span>
          <span class="support-product">{{ s.product }}</span>
          <span class="support-date num">{{ formatDate(s.support_till) }}</span>
        </div>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { BookOpen, MapPin, CircleAlert } from '@lucide/vue';

import { computed } from 'vue';
import moment from 'moment';

interface Props {
  property: Property;
}

const props = defineProps<Props>();

const activeSupport = computed(() => {
  return props.property?.supporters?.filter((s) => s.support_till || s.support_suspended) || [];
});

const hasActiveSupport = computed(() => {
  return activeSupport.value.length > 0;
});

function isOverdueSupport(date: any): boolean {
  return moment(date, 'YYYY-MM-DD').diff(Date.now()) < 0;
}

function formatDate(date: string): string {
  return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
}
</script>
